import usePersistentContext from './usePersistentContext';

export enum HintType {
  STAKE,
  UNSTAKE,
  VNO,
}

const useShowHowItWorks = (
  hintType: HintType,
): [boolean, (showHowItWorks: boolean) => void] => {
  const [value, setValue] = usePersistentContext(
    `${hintType}-show-how-it-works`,
  );
  const setShowHowItWorks = (showHowItWorks: boolean) => {
    setValue(`${showHowItWorks}`);
  };
  return [value !== 'false', setShowHowItWorks];
};

export default useShowHowItWorks;
